import { Injectable } from '@angular/core';
import { FileDownloadEvent, FileDownloadMonitorService as SVC } from '../domain/data-access-interfaces';
import { Result } from 'app/domain';
import { Observable } from 'rxjs';
import { AppSettings } from 'app/app-settings';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class FileDownloadMonitorService implements SVC {

  constructor(
    private appSettings: AppSettings,
    private http: HttpClient
  ) { }
  
  public saveFileDownloadEvent(committeeName: string, year: number): Promise<Result<string, string>> {
    return this.http.post(this.appSettings.APIURL + `/file_download_event/${year}/${committeeName}`, null)
    .pipe(map(json => 
        Result.fromJson(
            json, 
            (data: string) => data,
            (errorMsg: string) => errorMsg)))
    .toPromise();
  }

  public getFileDownloadEvent(periodOfReviewId: number, userId?: number): Observable<FileDownloadEvent[]> {

      let url = `${this.appSettings.APIURL}/file_download_event/${periodOfReviewId}`;
      
      url += userId ? `?userId=${userId}` : '';

      return this.http.get<FileDownloadEvent[]>(url)
          .pipe(
              map(response => response.map(FileDownloadEvent.fromJson))
          );
  }

}